import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnnounceIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.99951 2.70898L8.99951 10.6607",
		stroke: "white",
		strokeWidth: 2.23271
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.99951 12.9141L8.99951 14.827",
		stroke: "white",
		strokeWidth: 2.23271
	})]
});
export default SvgAnnounceIcon;
